import * as React from "react";
import { Link } from "react-router-dom";

export type PersonCardProps = {
  person: {
    id: number;
    name: string;
    profile_path?: string | null;
    known_for_department?: string;
  };
  /** Attach ref to root for infinite-scroll sentinel (last item) */
  innerRef?: React.Ref<HTMLElement>;
};

const PersonCard: React.FC<PersonCardProps> = ({ person, innerRef }) => {
  const src =
    person.profile_path && String(person.profile_path).length > 0
      ? `https://image.tmdb.org/t/p/w300${person.profile_path}`
      : "/images/no-image.jpg";
  const subtitle = person.known_for_department?.trim() || "—";

  return (
    <article className="person-card" ref={innerRef as React.Ref<HTMLDivElement>}>
      <Link to={`/person/${person.id}`} className="person-card-link">
        <div className="person-card-photo-wrap">
          <img
            src={src}
            alt={person.name}
            className="person-card-photo"
            decoding="async"
          />
        </div>
        <div className="person-card-body">
          <h3 className="person-card-name">{person.name}</h3>
          <p className="person-card-dept">{subtitle}</p>
        </div>
      </Link>
    </article>
  );
};

export default PersonCard;
